import { type FC } from 'react';
import { useRouter } from 'next/router';
import ArrowDownIcon from 'public/assets/common/icons/arrowDownDouble.svg';
import { getIsWithWidgets, getLinePageAnalyticsEvents, getSegmentScoresEntries, getWidgetsTabs, isMatchWidgetTab, useLineBehaviorV2, useToggle } from '@mwl/core-lib';
import { routes } from '@/constants';
import { widgetsIcons } from '../../LinePage.constants';
import { MatchScores } from '../MatchScores/MatchScores';
import { MatchTopNav } from '../MatchTopNav/MatchTopNav';
import { MatchWidget } from '../MatchWidget/MatchWidget';
import type { MatchInfoMobileProps } from './MatchInfoMobile.types';
import styles from './MatchInfoMobile.module.scss';
export const MatchInfoMobile: FC<MatchInfoMobileProps> = ({
  line,
  renderCompetitors,
  className,
  isFavorite
}) => {
  const [expanded, toggleExpanded] = useToggle(false);
  const {
    hasTranslation
  } = useLineBehaviorV2({
    line,
    routes
  });
  const router = useRouter();
  const {
    id: lineId,
    sport,
    stage
  } = line;
  const widgetsTabs = getWidgetsTabs({
    hasTranslation,
    hasWidgets: false,
    stage,
    iconMap: widgetsIcons
  });
  const segmentedScores = getSegmentScoresEntries(line);
  const handleExpandedChange = () => toggleExpanded();
  const isWithWidgets = getIsWithWidgets(line, false, hasTranslation);
  const analyticsData = getLinePageAnalyticsEvents(router.asPath, line);
  return <div className={cn(styles.root, className)} data-sentry-component="MatchInfoMobile" data-sentry-source-file="MatchInfoMobile.tsx">
      <MatchTopNav className={styles.topNav} tabs={widgetsTabs} hasTranslation={hasTranslation} lineId={lineId} isFavorite={isFavorite} analyticsAddFavorites={analyticsData.addFavorite} analyticsDeleteFavorites={analyticsData.delFavorite} data-sentry-element="MatchTopNav" data-sentry-source-file="MatchInfoMobile.tsx">
        {activeTab => <>
            <div className={cn(styles.stats, {
          [styles.statsWithScores]: !!segmentedScores.length
        })}>
              {renderCompetitors(expanded)}
            </div>

            {!!segmentedScores.length && <button type="button" className={cn(styles.expand, {
          [styles.active]: expanded
        })} onClick={handleExpandedChange}>
                <ArrowDownIcon className={styles.expandArrow} />
              </button>}

            {line && expanded && <div className={styles.scores}>
                <MatchScores className={styles.scoresTable} segmentedScores={segmentedScores} sportCode={sport.code} />
              </div>}

            {isWithWidgets && isMatchWidgetTab(activeTab) && <MatchWidget className={styles.matchWidget} line={line} activeTab={activeTab} />}
          </>}
      </MatchTopNav>
    </div>;
};